
export default function GamePicker({ session, onSelect, onBack }) {
  return (
    <div style={styles.screen}>
      <div style={styles.body}>
        <div style={styles.subtitle}>SELECT A GAME</div>
        <button style={styles.gameCard} onClick={() => onSelect('golf')}>
          <div style={styles.gameIcon}>⛳</div>
          <div style={styles.gameInfo}>
            <div style={styles.gameName}>Golf</div>
            <div style={styles.gameDesc}>Stroke play, Nassau, Skins, Match Play & more</div>
          </div>
          <div style={styles.gameArrow}>→</div>
        </button>
      </div>
    </div>
  )
}

const styles = {
  screen: { minHeight: '100vh', background: '#FDF9E7', display: 'flex', flexDirection: 'column', fontFamily: "'DM Sans', sans-serif", overflowX: 'hidden', width: '100%' },
  header: { background: '#0A0A0A', padding: '48px 24px 20px', display: 'flex', alignItems: 'center', gap: 16, flexShrink: 0 },
  backBtn: { background: 'none', border: 'none', color: '#C19A6B', fontSize: 24, cursor: 'pointer', padding: 0, lineHeight: 1 },
  headerTitle: { fontFamily: "'Outfit', sans-serif", fontWeight: 700, fontSize: 28, color: '#FDF9E7', letterSpacing: 2 },
  body: { flex: 1, padding: '32px 24px', display: 'flex', flexDirection: 'column', gap: 16 },
  subtitle: { fontSize: 11, fontWeight: 700, color: '#7A7570', letterSpacing: 2, marginBottom: 8 },
  gameCard: { background: '#FFFFFF', border: '1.5px solid #E0DDD4', borderRadius: 20, padding: '20px 20px', display: 'flex', alignItems: 'center', gap: 16, cursor: 'pointer', fontFamily: 'inherit', textAlign: 'left', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', transition: 'border-color 0.15s' },
  gameIcon: { fontSize: 36, flexShrink: 0 },
  gameInfo: { flex: 1 },
  gameName: { fontFamily: "'Bebas Neue', sans-serif", fontSize: 24, color: '#1A1814', letterSpacing: 1, marginBottom: 4 },
  gameDesc: { fontSize: 13, color: '#7A7570', lineHeight: 1.5 },
  gameArrow: { fontSize: 20, color: '#00563F', fontWeight: 700, flexShrink: 0 },
}
